export default "__VITE_ASSET__pT0Wz7Ai__"